import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { catchError, finalize } from 'rxjs/operators';
import { of } from 'rxjs';
import { CommunicationService } from '../services/communication.service';
import { UiFlowStateService } from '../services/ui-flow-state.service';
import { PhoneWCountrySimpleComponent } from '../shared/phone-w-country-simple/phone-w-country-simple.component';
import { FrontendContentConfigService } from '../services/frontend-content-config.service';
import { LoadingIndcatorServiceService } from '../services/loading-indcator-service.service';
import { DiscoveryStoreService } from '../services/discovery.service';
import { CPMixPanel } from '../services/mixpanel.service';

@Component({
  selector: 'cp-cp-common-success-refactor',
  templateUrl: './cp-common-success-refactor.component.html',
  styleUrls: ['./cp-common-success-refactor.component.scss']
})
export class CpCommonSuccessRefactorComponent implements OnInit {
  
  @HostListener('window:beforeunload', ['$event'])
  closePage($event: any) {
    this.uiFlowState.clearSessionStorage();
  }

  @ViewChild(PhoneWCountrySimpleComponent) phoneWCountry: PhoneWCountrySimpleComponent;
  countryId: string;
  phoneNumber: string;
  serverErrorMessage: string;
  driverAccountURL: string;
  // EU has the released app: show app-store links + QR instead of the SMS "text me the app" flow.
  isEu = false;
  // QR points at a static redirect page that sniffs the scanning device's OS: iOS -> App Store, else -> Google Play.
  qrDownloadUrl = `${window.location.origin}/assets/app-download.html`;
  constructor(
    private uiFlowState: UiFlowStateService,
    private commSvc: CommunicationService,
    private frontEndConfig: FrontendContentConfigService,
    private loadingIndicatorService: LoadingIndcatorServiceService,
    private discoveryService: DiscoveryStoreService,
    private mixPanel: CPMixPanel
    ) { }

  ngOnInit(): void {
    this.frontEndConfig.setBodyTitle('successTitle');
    this.uiFlowState.setSignUpFinished();
    this.isEu = !!this.discoveryService.getDiscoveryData()?.endPoints?.accounts_endpoint?.value?.includes('eu');
    // Phone + country only feed the non-EU SMS form; EU shows app-store links + QR instead, so skip it there.
    if (!this.isEu) {
      this.phoneNumber = this.commSvc.getPhoneNumber();
      this.countryId = this.commSvc.getDriverCountry()?.id?.toString() || '';
    }
    this.driverAccountURL = this.commSvc.getViewAccountLink();
  }

  clickDownload(market: string) {
    if (market === 'apple') {
      this.mixPanel.successAppleApp();
    } else if (market === 'google') {
      this.mixPanel.successGoogleApp();
    }
  }

  isFormInvalid() {
    return this.phoneWCountry.phoneWithCountryForm.invalid;
  }

  getFormData() {
    return {
      phone: {
        countryId: this.phoneWCountry.phoneWithCountryForm.controls.countryId.value,
        phone: this.phoneWCountry.phoneWithCountryForm.controls.phoneNumber.value
      }
    };
  }

  onSubmitForm() {
    this.serverErrorMessage = null;
    if (this.isFormInvalid()) {
      return;
    }
    const phoneFormData = this.getFormData();
    this.loadingIndicatorService.loadingRequestStarted('common-success-refactor');
    // this.uiFlowState.$isLoading.next(true);
    this.commSvc.pushToBackend(phoneFormData, 'thankyou').pipe(
      catchError(err => {
        this.handleError(err);
        return of(null);
      }),
      finalize(() => this.loadingIndicatorService.loadingRequestFinished())
    ).subscribe(); 
  }

  handleError(err) {
    this.serverErrorMessage = err.error?.errorMessage || 'Server Error';
  }
}
